import { Message } from '../types/chat';

// Format date for message grouping
export const formatMessageDate = (date: Date): string => {
  const now = new Date();
  const messageDate = new Date(date);
  const diffTime = now.getTime() - messageDate.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return 'Hôm nay';
  } else if (diffDays === 1) {
    return 'Hôm qua';
  } else {
    return messageDate.toLocaleDateString('vi-VN', {
      weekday: 'long',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }
};

// Group messages by date
export const groupMessagesByDate = (messages: Message[]) => {
  const groups: { [key: string]: Message[] } = {};
  
  messages.forEach(message => {
    // Handle both Date objects and timestamp strings
    const timestamp = message.timestamp instanceof Date 
      ? message.timestamp 
      : new Date(message.timestamp);
    const dateKey = timestamp.toDateString();
    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }
    groups[dateKey].push(message);
  });

  return Object.entries(groups).map(([dateKey, messages]) => ({
    date: new Date(dateKey),
    messages
  }));
};

// Check if browser supports speech recognition
export const isSpeechRecognitionSupported = (): boolean => {
  return 'webkitSpeechRecognition' in window || 'SpeechRecognition' in window;
};

// Generate random assistant response
export const getRandomAssistantResponse = (responses: readonly string[]): string => {
  return responses[Math.floor(Math.random() * responses.length)];
};

// Format timestamp for display
export const formatMessageTime = (timestamp: Date): string => {
  return timestamp.toLocaleTimeString('vi-VN', {
    hour: '2-digit',
    minute: '2-digit'
  });
};
